import img from '../img/1.jpg';
import { Link } from 'react-router-dom';

const Person = (props) => {
	return (
		<div className="person-cont flex-start">
			<div className="person-img-cont">
				<Link to="/Mybeats">
					<img
						src={props.dp}
						className="person-img"
						onClick={(e) => {
							localStorage.setItem('person-phone',props.phone);
						}}
					/>
				</Link>
			</div>
			<div className="person-det flex-col-evenly">
				<span>{props.name}</span>
				<p>{props.caption}</p>
			</div>
		</div>
	);
};

export default Person;
